module.exports = __webpack_public_path__ + "6c166c6ef5c55646082ce42442f12c9d.svg";


//////////////////
// WEBPACK FOOTER
// ./images/shape.svg
// module id = 63
// module chunks = 0